var e = /* @__PURE__ */ ((r) => (r.Base = "iress-u-row", r.Gutter = "iress--gutter", r.HorizontalAlign = "iress--h-align", r.VerticalAlign = "iress--v-align", r.UseColGap = "iress--use-col-gap", r))(e || {});
export {
  e as RowCssClass
};
